import axios from 'axios'
import { API_ENDPOINT } from '../../../../config'
import store from '../../../../redux/stores/store'
import Validation from '../../../../data/validation/validation'
import { DateValidationRule, StringValidationRule } from '../../../../data/validation/rules'
import {LoadJournals} from '../article.worker'
import { ScrollIntoViewById } from '../../../../utils/UIHelper'

const getAbstractText = (value) => {
    return (value || "")
        .replace(/<[^>]*>/g, " ")
        .replace(/&nbsp;/gi, " ")
        .replace(/&amp;/gi, "&")
        .replace(/\s+/g, " ")
        .trim()
}

const getContentText = (instance) => {
    return instance.state.contentType === "2"
        ? getAbstractText(instance.state.fullText)
        : getAbstractText(instance.state.abstract)
}

const getDefaultState = () => {
    return {
        creating: false,
        loadingJournals: false,
        title: "",
        journalId: "",
        publicationDate: "",
        contentType: "1",
        abstract: "",
        fullText: "",
        keyAbstract: Math.random(),
        keyFullText: Math.random(),
        errors: {},
        journals: [],
        flag: {
            type: "",
            text: ""
        }
    }
}

const createArticle = (instance) => {
    instance.setState({
        ...instance.state,
        creating: true
    })
    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/article/create",
        headers: {
            "Authorization": store.getState().auth.authorization
        },
        data: {
            Authorization: store.getState().auth.authorization,
            title: instance.state.title,
            journalId: instance.state.journalId,
            publicationDate: instance.state.publicationDate,
            contentType: Number(instance.state.contentType),
            abstract: instance.state.abstract,
            fullText: instance.state.fullText,
        }
    }).then(response => handleCreateArticleResponse(instance, response))
    .catch(error => {
        instance.setState({
            ...instance.state,
            creating: false
        })
        alert(error)
    })
}

const handleCreateArticleResponse = (instance, response) => {
    if(response.status !== 200){
        return
    }
    ScrollIntoViewById("createArticle")
    switch (response.data.status) {
        case 200:
            instance.setState({
                ...getDefaultState(),
                flag: {
                    type: "success",
                    text: "Article Created"
                }
            })
            break
        default:
            instance.setState({
                ...instance.state,
                creating: false,
                flag: {
                    type: "error",
                text: response.data.message
                }
            })
    }
}

const isValid = (instance) => {
    const validation = new Validation()
    const errors = {}

    validation.addValidationRule(StringValidationRule, instance.state.title, (error) => errors.title = error, { min: { value: 2, error: "Too short" }, max: { value: 650, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.journalId, (error) => errors.journalId = error, { min: { value: 20, error: "Too short" }, max: { value: 45, error: "Too long" } })
    validation.addValidationRule(DateValidationRule, instance.state.publicationDate, (error) => errors.publicationDate = error, { allowNull: false })

    if (instance.state.contentType === "2") {
        validation.addValidationRule(StringValidationRule, getContentText(instance), (error) => errors.fullText = error, { min: { value: 5, error: "Too short" }, max: { value: 9000000, error: "Too long" } })
    } else {
        validation.addValidationRule(StringValidationRule, getContentText(instance), (error) => errors.abstract = error, { min: { value: 5, error: "Too short" }, max: { value: 9000000, error: "Too long" } })
    }

    const validate = validation.validate()

    instance.setState({
        ...instance.state,
        errors: errors,
        flag: {
            type: validate ? "" : "error",
            text: validate ? "" : "Validation Failure"
        }
    })

    return validate
}

const CreateArticleWorker = instance => {
    return {
        getDefaultState: getDefaultState,
        isValid: () => isValid(instance),
        loadJournals: () => LoadJournals(instance),
        createArticle: () => createArticle(instance)
    }
}

export default CreateArticleWorker
